import { ServiceConfig } from '../../../../shared/services/ServiceConfig'
import ContatoResponse from '../../domain/entities/Contato'
import { IContatoRepository } from '../../domain/repositories/IContatosRepository'

const http = new ServiceConfig()

export default class ContatoRepository implements IContatoRepository {
  public async getContato(): Promise<ContatoResponse[]> {
    const response = await http.get('/contatos')

    return response.data as ContatoResponse[]
  }
}
